import { getDocumentPageUrl } from './url-helpers';
import { openPopup } from './utils';
export function sharePublicationOnTwitter(config, publication, pageNumber) {
    shareLinkOnTwitter(config, {
        title: publication.title,
        url: getDocumentPageUrl({
            mainHost: config.hosts.main,
            username: publication.username,
            documentName: publication.name,
            pageNumber,
        }),
    });
}
export function shareLinkOnTwitter(config, link) {
    openPopup({
        url: 'https://twitter.com/intent/tweet',
        params: {
            text: link.title,
            url: link.url,
            via: 'issuu',
            related: 'issuu',
            original_referer: `https://${config.hosts.main}`,
        },
    });
}
//# sourceMappingURL=twitter.js.map